/**
 * Maps frontend-extended coverage types back to the V5 API values
 * used by the Go backend.
 *
 * The frontend splits "dental" into "dental-ppo" and "dental-hmo" for
 * UI routing / LOC config, but proposals from the API still carry the
 * original V5 value ("dental").  This helper normalises any
 * frontend-extended value so it can be compared against proposal data.
 */

import { CoverageTypeEnum } from "@platform/types";

/** Normalise a frontend CoverageTypeEnum back to the V5 API value. */
export const toV5CoverageType = (coverageType: string): string => {
  switch (coverageType) {
    case CoverageTypeEnum.DENTAL_PPO:
    case CoverageTypeEnum.DENTAL_HMO:
      return CoverageTypeEnum.DENTAL; // "dental"
    default:
      return coverageType;
  }
};

/**
 * Checks whether a proposal coverage's type matches a (possibly
 * frontend-extended) coverage type.
 *
 * Example:
 *   proposalCoverageType = "dental"  (from API)
 *   queriedType          = "dental-ppo" (from UI)
 *   → true (both normalise to "dental")
 */
export const matchesProposalCoverageType = (
  proposalCoverageType: string,
  queriedType: string,
): boolean =>
  toV5CoverageType(proposalCoverageType) === toV5CoverageType(queriedType);
